import { render } from "./VwTapGrid.vue?vue&type=template&id=200db9ba"
import script from "./VwTapGrid.vue?vue&type=script&lang=js"
export * from "./VwTapGrid.vue?vue&type=script&lang=js"

import "./VwTapGrid.vue?vue&type=style&index=0&id=200db9ba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__